/* UtilBrowserDetection util */
import Bowser from 'bowser';
import MobileDetect from 'mobile-detect';
/**
 * Browser-Detection-Class which encapsulates Bowser and Mobile-Detect
 */
export default class UtilBrowserDetection {
    constructor() {
        /**
         * @private
         */
        this._browser = Bowser.getParser(window.navigator.userAgent);
        /**
         * @private
         */
        this._mobileDetect = new MobileDetect(window.navigator.userAgent);
    }
    /**
     * Checking the device type
     * @return {DeviceType}
     * @deprecated Use getDevice();
     */
    checkDeviceType() {
        return this.getDeviceType();
    }
    /**
     * Checking the OS
     * @return {string}
     * @deprecated Use getOS();
     */
    checkOs() {
        return this.getOs();
    }
    /**
     * Checking the _browser
     * @return {string}
     * @deprecated Use getBrowser();
     */
    checkBrowser() {
        return this.getBrowser();
    }
    /**
     * Returns the device type
     * @return {DeviceType}
     * @see https://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html
     */
    getDeviceType() {
        if (this._iOSWorkaroundCheck())
            return DeviceType.TABLET;
        if (this._mobileDetect.phone() !== null)
            return DeviceType.PHONE;
        if (this._mobileDetect.tablet() !== null)
            return DeviceType.TABLET;
        return DeviceType.DESKTOP;
    }
    /**
     * Returns the OS name
     * @return {string}
     * @see http://lancedikson.github.io/bowser/docs/Parser.html#getOSName
     */
    getOs() {
        if (this._iOSWorkaroundCheck())
            return 'ios';
        return this._browser.getOSName(true);
    }
    /**
     * Returns the _browser name
     * @return {string}
     * @see http://lancedikson.github.io/bowser/docs/Parser.html#getBrowserName
     */
    getBrowser() {
        return this._browser.getBrowserName().toLowerCase();
    }
    /**
     * Returns the device information (type and device)
     * @return {Device}
     * @see https://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html
     */
    getDevice() {
        let currentDevice = this._iOSWorkaroundCheck() ? 'iPad' : this._mobileDetect.mobile();
        if (currentDevice == undefined)
            currentDevice = null;
        return {
            type: this.getDeviceType(),
            device: currentDevice,
        };
    }
    /**
     * TODO: remove this if apple fixed it in safari
     * https://developer.apple.com/forums/thread/119186
     * @private
     */
    _iOSWorkaroundCheck() {
        // hack to detect new iPads
        return ((/iPad/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
            // @ts-expect-error migrated from ts-ignore
            !window.MSStream);
    }
}
export var DeviceType;
(function (DeviceType) {
    DeviceType["PHONE"] = "phone";
    DeviceType["TABLET"] = "tablet";
    DeviceType["DESKTOP"] = "desktop";
})(DeviceType || (DeviceType = {}));
